import { Link } from 'react-router-dom';

const highlights = [
  { label: 'Qualität', desc: 'Erstklassige Materialien und handwerkliche Präzision' },
  { label: 'Termingarantie', desc: 'Wir halten unsere Zeitpläne – immer' },
  { label: 'Festpreise', desc: 'Transparente Kalkulationen ohne versteckte Kosten' },
  { label: 'Erfahrung', desc: 'Über 10 Jahre Bau- und Sanierungserfahrung in NRW' },
];

export default function AboutSection() {
  return (
    <section className="py-12 sm:py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Text */}
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Über uns
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              <strong>IGM Facility Service</strong> steht seit über 10 Jahren für professionelle
              Bau- und Sanierungsdienstleistungen in Ratingen und der gesamten Region NRW. Wir
              realisieren Projekte jeder Größe – von der Kernsanierung bis zum schlüsselfertigen
              Neubau.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              Unser eingespieltes Team aus erfahrenen Handwerkern, Bauleitern und Fachplanern
              sorgt dafür, dass Ihr Bauprojekt termingerecht, im Budget und in höchster Qualität
              fertiggestellt wird.
            </p>

            <div className="bg-[#0D2B4E]/5 border-l-4 border-[#0D2B4E] rounded-lg p-3 sm:p-4 mb-6 sm:mb-8">
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-lg sm:text-xl text-[#0D2B4E]" />
                </div>
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
                  <strong>Aus der Praxis für die Praxis:</strong> Durch den Zusammenschluss mit{' '}
                  <strong>Amaterasu Facility</strong> im Jahr 2024 haben wir unser Portfolio
                  erheblich erweitert und bieten Ihnen heute das komplette Spektrum von Neubau bis
                  zur Gebäudesanierung.
                </p>
              </div>
            </div>

            <div className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
              {highlights.map((item) => (
                <div key={item.label} className="flex items-start gap-2 sm:gap-3">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#0D2B4E] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                    <i className="ri-check-line text-white text-xs sm:text-sm" />
                  </div>
                  <p className="text-sm sm:text-base text-gray-700">
                    <strong>{item.label}:</strong> {item.desc}
                  </p>
                </div>
              ))}
            </div>

            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <span>Projekt anfragen</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden w-full h-auto">
                <img
                  src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/06c5a492ce4163d31f2cea52f8cee880.jpeg"
                  alt="Unser Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 w-32 h-32 sm:w-48 sm:h-48 bg-[#0D2B4E] rounded-2xl -z-10" />
              <div className="absolute -top-4 -left-4 sm:-top-6 sm:-left-6 w-32 h-32 sm:w-48 sm:h-48 bg-[#0D2B4E]/10 rounded-2xl -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
